<template>
  <div>
    <generic-table
      ref="datatable"
      :show_refresh="false"
      :title="$t('point of purchase')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      resource_url="/purchase/product/datatables"
      @selected="$emit('selected', $event)"
    />
  </div>

  <product-modal ref="product_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import ProductModal from "./product_modal/Index.vue";

export default {
  name: "OrdersDatatable",
  components: { GenericTable, ProductModal },
  data() {
    let v = this;
    return {
      extra_buttons: [
        // {
        //   text: v.$t("add"),
        //   icon: "fa fa-plus",
        //   class: "is-secondary is-rounded",
        //   click: this.create,
        // },
      ],
      columns: [
        {
          orderable: false,
          title: v.$t("name"),
          name: "name",
          width: "50%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          orderable: false,
          title: v.$t("barcode"),
          name: "barcode",
          width: "50%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.barcode || "";
          },
        },
        // {
        //   orderable: false,
        //   title: v.$t("sale price"),
        //   name: "sale_price",
        //   width: "20%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return format_currency(row.sale_price) || "";
        //   },
        // },
        // {
        //   title: v.$t("options"),
        //   searchable: false,
        //   data: (row) => {
        //     return generate_datatables_buttons([
        //       {
        //         args: { uuid: row.uuid },
        //         tooltip: v.$t("edit"),
        //         icon: "fa fa-edit",
        //         icon_class: "is-small",
        //         click: function (e) {
        //           console.log("edit order", e.detail.uuid);
        //           v.$refs.product_modal.show_modal(e.detail.uuid);
        //         },
        //       },
        //       {
        //         args: { uuid: row.uuid },
        //         tooltip: v.$t("delete"),
        //         icon: "fa fa-trash",
        //         icon_class: "is-small has-text-danger",
        //         click: (e) => {
        //           let uuid = e.detail.uuid;
        //           confirm_deletion_dialog(
        //             v.$t("are you sure to delete product?"),
        //             v,
        //             () => {
        //               del("/product", { uuid: uuid })
        //                 .then(() => {
        //                   v.refresh();
        //                 })
        //                 .catch((error) => {
        //                   error_message(error);
        //                 });
        //             }
        //           );
        //         },
        //       },
        //     ]);
        //   },
        // },
      ],
    };
  },
  methods: {
    // create() {
    //   let v = this;
    //   v.$refs.product_modal.show_modal();
    // },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
